<script setup lang="ts">
import TagIconFromTagInformations from '~/components/tag/card/iconFromTagInformations.vue'
import VCard from '~/components/ui/VCard.vue'

import type TagInformation from '~/types/tagInformations'

type Props = {
  tagInformations: TagInformation[]
  target: string
}

defineProps<Props>()
</script>

<template>
  <VCard class="tw-w-full" padding="5">
    <TagIconFromTagInformations
      :tag-informations="tagInformations"
      :img-src="`smiley_${target}.svg`"
      category-type="music-type"
    >
      <template #title>
        {{ $t(`influencer.profile.slug.universe.universe_${target}`) }}
      </template>
    </TagIconFromTagInformations>
  </VCard>
</template>
